import Hero from './components/Hero';
import About from './components/About';
import Courses from './components/Courses';
import Mentoring from './components/Mentoring';
import Contact from './components/Contact';
import Partners from './components/Partners';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Courses />
      <Mentoring />
      <Contact />
      <Partners />
      <Footer />
    </div>
  );
}
